var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDataSortingSizeDescending = function SvgDataSortingSizeDescending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3v2h11V3zm14 0v14h-3l4 4 4-4h-3V3zM3 7v2h9V7zm0 4v2h7v-2zm0 4v2h5v-2zm0 4v2h3v-2z"
  })));
};
export default SvgDataSortingSizeDescending;